'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _range = require('lodash/range');

var _range2 = _interopRequireDefault(_range);

var _pick = require('lodash/pick');

var _pick2 = _interopRequireDefault(_pick);

var _withStyles = require('../with-styles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _inputField = require('../input-field');

var _inputField2 = _interopRequireDefault(_inputField);

var _inputSelect = require('../input-select');

var _inputSelect2 = _interopRequireDefault(_inputSelect);

var _inputValidations = require('../input-validations');

var _inputValidations2 = _interopRequireDefault(_inputValidations);

var _label = require('../label');

var _label2 = _interopRequireDefault(_label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputDate = function (_Component) {
  _inherits(InputDate, _Component);

  function InputDate(props) {
    _classCallCheck(this, InputDate);

    var _this = _possibleConstructorReturn(this, (InputDate.__proto__ || Object.getPrototypeOf(InputDate)).call(this, props));

    _this.updateDay = _this.updateDay.bind(_this);
    _this.updateMonth = _this.updateMonth.bind(_this);
    _this.updateYear = _this.updateYear.bind(_this);
    _this.updateDate = _this.updateDate.bind(_this);

    _this.state = {
      touched: !!props.value,
      showSelects: props.showSelects,
      value: props.value,
      date: props.value ? (0, _moment2.default)(props.value) : (0, _moment2.default)()
    };
    return _this;
  }

  _createClass(InputDate, [{
    key: 'testDateInput',
    value: function testDateInput() {
      try {
        var test = document.createElement('input');
        test.type = 'date';
        return test.type === 'text';
      } catch (error) {
        return true;
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.testDateInput()) this.setState({ showSelects: true });
    }
  }, {
    key: 'updateDay',
    value: function updateDay(day) {
      var date = this.state.date.date(day);
      this.updateDate(date);
    }
  }, {
    key: 'updateMonth',
    value: function updateMonth(month) {
      var date = this.state.date.month(month);
      this.updateDate(date);
    }
  }, {
    key: 'updateYear',
    value: function updateYear(year) {
      var date = this.state.date.year(year);
      this.updateDate(date);
    }
  }, {
    key: 'updateDate',
    value: function updateDate(moment) {
      this.setState({ date: moment, touched: true });
      this.props.onChange(moment.format('YYYY-MM-DD'));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$required = _props.required,
          required = _props$required === undefined ? false : _props$required,
          classNames = _props.classNames,
          error = _props.error,
          id = _props.id,
          label = _props.label,
          name = _props.name,
          _props$styles = _props.styles,
          styles = _props$styles === undefined ? {} : _props$styles,
          validations = _props.validations;
      var _state = this.state,
          showSelects = _state.showSelects,
          touched = _state.touched,
          _state$date = _state.date,
          date = _state$date === undefined ? (0, _moment2.default)() : _state$date;


      var labelId = 'label-' + (id || name);
      var allowedProps = (0, _pick2.default)(this.props, ['disabled', 'placeholder', 'required']);
      var months = [{ label: 'January', value: 0 }, { label: 'February', value: 1 }, { label: 'March', value: 2 }, { label: 'April', value: 3 }, { label: 'May', value: 4 }, { label: 'June', value: 5 }, { label: 'July', value: 6 }, { label: 'August', value: 7 }, { label: 'September', value: 8 }, { label: 'October', value: 9 }, { label: 'November', value: 10 }, { label: 'December', value: 11 }];
      var daysInMonth = date.daysInMonth() || 31;

      var mapValues = function mapValues(array) {
        return array.map(function (value) {
          return { label: value, value: value };
        });
      };

      return showSelects ? _react2.default.createElement(
        'div',
        { className: 'c11n-input-date ' + classNames.root, id: id },
        label && _react2.default.createElement(
          _label2.default,
          {
            id: labelId,
            required: required,
            styles: {
              root: styles.label,
              required: styles.required
            }
          },
          label
        ),
        _react2.default.createElement(
          'div',
          { className: classNames.wrapper },
          _react2.default.createElement(_inputSelect2.default, _extends({}, allowedProps, {
            styles: styles.input,
            value: touched ? date.date().toString() : '',
            onChange: this.updateDay,
            onBlur: this.updateDay,
            label: 'Day',
            name: name + '-day',
            'aria-labelledby': labelId,
            options: [{ label: 'Day', value: '', disabled: true }].concat(_toConsumableArray(mapValues((0, _range2.default)(1, daysInMonth + 1))))
          })),
          _react2.default.createElement(_inputSelect2.default, _extends({}, allowedProps, {
            styles: styles.input,
            value: touched ? date.month().toString() : '',
            onChange: this.updateMonth,
            onBlur: this.updateMonth,
            label: 'Month',
            name: name + '-month',
            'aria-labelledby': labelId,
            options: [{ label: 'Month', value: '', disabled: true }].concat(months)
          })),
          _react2.default.createElement(_inputSelect2.default, _extends({}, allowedProps, {
            styles: styles.input,
            value: touched ? date.year().toString() : '',
            onChange: this.updateYear,
            onBlur: this.updateYear,
            label: 'Year',
            name: name + '-year',
            'aria-labelledby': labelId,
            options: [{ label: 'Year', value: '', disabled: true }].concat(_toConsumableArray(mapValues((0, _range2.default)(1900, parseInt((0, _moment2.default)().year() + 1)))))
          }))
        ),
        error && _react2.default.createElement(_inputValidations2.default, {
          styles: { root: styles.error },
          validations: validations
        })
      ) : _react2.default.createElement(_inputField2.default, _extends({ type: 'date' }, this.props));
    }
  }]);

  return InputDate;
}(_react.Component);

exports.default = (0, _withStyles2.default)(_styles2.default)(InputDate);


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/input-date/index.js
// module id = 832
// module chunks = 0